let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page017_game10/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 259,
      y: 138,
    },
  },
  activeArea: {
    width: 60,
    height: 60,
    fontSize: 39,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      direction: 'left',
      textObj: {
        text: 'Kliknij prawym przyciskiem myszy na zaznaczonym obrazku.',
      },
      audio: {
        src: 'games/page017_game10/audio/z8s17-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 594,
        y: 636,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Kliknij lewym przyciskiem myszy <br/>w polecenie <i>Kopiuj.</i>',
      },
      audio: {
        src: 'games/page017_game10/audio/z8s17-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1037,
        y: 496,
      },
    },
  ],
};
export default elements;
